import { SipPlanMode } from '../../../api/types'
import {
  isSipIdealPlansFetchFailed,
  isSipIdealPlansLoading,
  useSipPlansContext
} from '../../SipPlansProvider'
import { PlansCategoryListSkeleton } from '../../../../lumpsum/plans-list/lumpsum-ui-components/PlansCategoryListSkeleton'
import { IdealSipCategoryList } from './IdealSipCategoryList'
import { IdealSipPlansListErrorState } from './IdealSipPlansListErrorState'
import { SipIdealBlurredBody } from './SipIdealBlurredBody'

/** Rolled-out Ideal SIPs body: locked (not Prime) or full list. */
export function SipIdealBody() {
  const { plansOverview, plansQuery } = useSipPlansContext()

  if (isSipIdealPlansLoading(SipPlanMode.IDEAL_SIPS, plansOverview != null, plansQuery)) {
    return <PlansCategoryListSkeleton />
  }

  if (isSipIdealPlansFetchFailed(SipPlanMode.IDEAL_SIPS, plansQuery)) {
    return <IdealSipPlansListErrorState onRetry={plansQuery.refetch} />
  }

  if (plansOverview?.isPlanSubscriptionEligible !== true) {
    return <SipIdealBlurredBody />
  }

  return <IdealSipCategoryList />
}
